module.exports = __webpack_public_path__ + "img/mobileResidentOffice3.7f076045.png";